export const selectStatistics = (state) => state.statistics;
export const selectStatisticsPeriod = (state) => state.statistics.period;
export const selectStatisticsLoading = (state) => state.statistics.isLoading;
export const selectStatisticsError = (state) => state.statistics.isError;
export const selectStatisticsMessage = (state) => state.statistics.message;
export const selectStatisticsMeetings = (state) => state.statistics.meetings;
export const selectStatisticsTranscripts = (state) => state.statistics.transcripts;
export const selectStatisticsAssemblyAI = (state) => state.statistics.assemblyAI;
export const selectStatisticsConnections = (state) => state.statistics.connections;
export const selectStatisticsConnectionSummary = (state) => state.statistics.connectionSummary;
